import { ColumnsProps } from 'components/Table/Table'
import i18n from 'i18n'

export const columns = (): ColumnsProps[] => [
  {
    align: 'center',
    fixed: true,
    name: 'codigoBarrasMp',
    title: i18n.t('tables:barCode')
  },
  {
    align: 'center',
    fixed: true,
    name: 'skuCodigo',
    title: i18n.t('tables:productCode')
  },
  {
    align: 'left',
    fixed: true,
    name: 'skuDescricao',
    title: i18n.t('tables:productDescription')
  },
  {
    align: 'left',
    fixed: false,
    name: 'skuDescricaoVenda',
    title: i18n.t('tables:descriptionSale')
  },
  {
    align: 'left',
    fixed: false,
    name: 'dtAbate',
    title: i18n.t('tables:slaughterDate')
  },
  {
    align: 'left',
    fixed: false,
    name: 'nrUnidadeAbate',
    title: i18n.t('tables:slaughterSIF')
  },
  {
    align: 'left',
    fixed: false,
    name: 'dtProducao',
    title: i18n.t('tables:productionData')
  },
  {
    align: 'left',
    fixed: false,
    name: 'dtValidade',
    title: i18n.t('tables:expiryDate')
  },
  {
    align: 'left',
    fixed: false,
    name: 'sifProducao',
    title: i18n.t('tables:productionSIF')
  },
  {
    align: 'left',
    fixed: false,
    name: 'nfNumero',
    title: i18n.t('tables:invoiceNumber')
  },
  {
    align: 'left',
    fixed: false,
    name: 'cnpjLocalEstoque',
    title: i18n.t('tables:localStockCnpj')
  },
  {
    align: 'left',
    fixed: false,
    name: 'razaoSocialLocalEstoque',
    title: i18n.t('tables:localStockCompanyName')
  },
  {
    align: 'left',
    fixed: false,
    name: 'dtExpedicao',
    title: i18n.t('tables:shippingDate')
  },
  {
    align: 'center',
    fixed: false,
    name: 'pesoBruto',
    title: i18n.t('tables:grossWeight')
  },
  {
    align: 'center',
    fixed: false,
    name: 'pesoLiquido',
    title: i18n.t('tables:netWeight')
  },
  {
    align: 'center',
    fixed: false,
    name: 'qtyCaixas',
    title: i18n.t('common:totalBoxVolume')
  }
]
